import { classNames } from '../utilities';

export const TemplatesExchangeIcon = ({ isFilled, className, onClick }) => {
  const fill = isFilled ? '#00D091' : '#000';

  return (
    <svg
      fill="none"
      className={classNames(className)}
      onClick={onClick}
      width="16px"
      height="16px"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M24 16H29V4L44 19L29 34V24H18V13L4 28L18 44V32H23"
          stroke={fill}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  );
};
